import brands from '@/brands/brands.json';
export function brandDetector() {
    var selected = 'euncet';
    if (!!brands[selected].hasFavicon) {
        var url = '/static/img/brands/' + selected + '/favicon/';
        document.head.querySelector("[name=big-favicon]").href = url + 'apple-touch-icon.png';
        document.head.querySelector("[name=medium-favicon]").href = url + 'favicon-32x32.png';
        document.head.querySelector("[name=small-favicon]").href = url + 'favicon-16x16.png';
        document.head.querySelector("[name=favicon]").href = url + 'favicon.ico';
        document.head.querySelector("[name=msapplication-config]").href = url + 'browserconfig.xml';
        document.head.querySelector("[name=webmanifest]").href = url + 'site.webmanifest';

    }
    return brands[selected];
}


// WEBPACK FOOTER //
// ./src/brands/index.js